<!-- Información de usuario logueado -->

<div class="row">
    <div>
        <img src="assets/user-avatar.png" class="imgSize">
        <span>
            <span class="csf1">{{nameSelectedChat? nameSelectedChat : ('RIGHT_BAR_USER_NO_ADDED' | translate) }}</span>
            <div class="csf2" *ngIf="!datos">{{selectedChat}}</div>
            <div class="csf2" >{{datos}}</div>
        </span>
    </div>


    <p-card *ngFor="let note of notes" [subheader]="note.date" [style]="{ width: '90%', margin: 'auto', textAlign:'center', fontSize:'10px' }">
        <p > {{ note.content }}</p>
        <ng-template pTemplate="footer">
            <!-- <p-button label="Save" icon="pi pi-check"></p-button> -->
            <!-- <p-button label="Eliminar" icon="pi pi-times" styleClass="p-button-secondary"
                [style]="{ 'margin-left': '.5em' }"></p-button> -->
        </ng-template>
    </p-card>
   


























    <!--  <p-divider></p-divider>
    <div>
        <h5 class="csf3">Información</h5>
         h5 class="csf4">Last message 7 days ago</h5>
        <h5 class="csf4"><i class="pi pi-user ccolor" ></i>  Personal account</h5>
        <h5 class="csf4"><i class="pi pi-flag ccolor"></i>  India</h5>
        <h5 class="csf4"><i class="pi pi-globe ccolor" ></i>  English Hindi</h5>
        <h5 class="csf4"><i class="pi pi-money-bill ccolor" ></i>  Indian Rupee</h5>
        <h5 class="csf4"><i class="pi pi-comment ccolor"></i>  Started 7 days ago</h5> 
</div>
<p-divider></p-divider>
<div>
    <h5 class="csf5" >Labels</h5>


</div>
<p-divider></p-divider>
<div>
    <h5 class="csf3">Contact</h5>
<h5 class="csf6">Name: <span class="csf7 ml-38">Test123</span></h5>
<h5 class="csf6">Country: <span class="csf7 ml-28">India</span></h5>
<h5 class="csf6">WhatsApp: <span class="csf7 ml-15">Personal account</span></h5>
</div>
<p-divider></p-divider> -->
</div>